import React from 'react';


export default function ({ sideBarData, eleRef }) {
   return (
          <div>
            {!eleRef.state.loggedin && eleRef.state.isMobile &&
            
              <section className="slideTemp child_login_section_div">
                  <div className="non_login_div_child">
                      <div className="B18_21 non_login_dnya" role="text" tabIndex={0} aria-label="Tell us more about yourself get More Personalised Feed"> Tell us more about yourself get More Personalised Feed</div>

                      <ul className="baby_child_login_circle_div">
                        <li className={eleRef.props.location.pathname=="/infant-0-6-months"?"baby_child1 active_cl":"baby_child1"}>
                        <a href="/infant-0-6-months" tabIndex={0} aria-label='Select profile : Infant 0 to 6 months'>
                          <div className="baby_circle_child1" >

                             <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/01 Infant.webp" alt="Infant - 0 to 6 M" title="Infant"/>

                            {/* <div className="child_edit"> 
                              <span data-icon-font="H" className="icon"></span>
                            </div>  */}
                          </div>
                          <h2 className="infant_name_baby M14_21"> Infant </h2>
                          <div className="infant_name_dis M14_61"> 0 to 6 M </div>
                       </a> 
			</li>
      <li className={eleRef.props.location.pathname=="/baby-0-2-years"?"baby_child1 active_cl":"baby_child1"}>
			<a href="/baby-0-2-years" tabIndex={0} aria-label='Select profile : Baby 6 months to 2 years'>
                          <div className="baby_circle_child1" >

                             <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/02 Baby.webp"  alt="Baby - 6 M to 2 yrs" title="Baby"/>

                            {/* <div className="child_edit"> 
                              <span data-icon-font="H" className="icon"></span>
                            </div>  */}
                          </div>
                          <h2 className="infant_name_baby M14_21"> Baby </h2>
                          <div className="infant_name_dis M14_61"> 6 M to 2 yrs </div>
                       </a> 
			</li>
                        <li className={eleRef.props.location.pathname=="/toddler-2-4-years"?"baby_child1 active_cl":"baby_child1"}>
                        <a href="/toddler-2-4-years" tabIndex={0} aria-label='Select profile : Toddler 2 to 4 years'>
                          <div className="baby_circle_child1">
                            <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/03 Toddler.webp" alt="Toddler - 2 to 4 yrs" title="Toddler"/> 
                          </div>
                          <h2 className="infant_name_baby M14_21"> Toddler </h2>
                          <div className="infant_name_dis M14_61">2 to 4 yrs </div>
                          </a>
                        </li>
                        <li className={eleRef.props.location.pathname=="/kid-4-plus-years"?"baby_child1 active_cl":"baby_child1"}>
                        <a href="/kid-4-plus-years" tabIndex={0} aria-label='Select profile : Kids 4 to 6 years'>
                          <div className="baby_circle_child1">
                            <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/04 Kids.webp" alt="Kids - 4 to 6 yrs" title="Kids"/> 
                          </div>
                          <h2 className="infant_name_baby M14_21"> Kids </h2>
                          <div className="infant_name_dis M14_61">  4 to 6 yrs </div>
                          </a>
                        </li>
                        <li className={eleRef.props.location.pathname=="/big-kid-6-plus-years"?"baby_child1 active_cl":"baby_child1"}>
                        <a href="/big-kid-6-plus-years" tabIndex={0} aria-label='Select profile : Big Kids 6 years and above'>
                          <div className="baby_circle_child1">
                            <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/05 Big Kids.webp"  alt="Big Kids - 6+ yrs" title="Big Kids"/> 
                          </div>
                          <h2 className="infant_name_baby M14_21">Big Kids </h2>
                          <div className="infant_name_dis M14_61">  6+ yrs </div>
                          </a>
                        </li>
                        <li className={eleRef.props.location.pathname=="/expecting"?"baby_child1 active_cl":"baby_child1"}>
                        <a href="/expecting" tabIndex={0} aria-label='Select profile : Expecting'>
                          <div className="baby_circle_child1">
                            <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/06 Expecting.webp" alt="Expecting" title="Expecting"/> 
                          </div>
                          <h2 className="infant_name_baby M14_21"> Expecting </h2>
                          <div className="infant_name_dis M14_61">  </div>
                          </a>
                        </li>
                        <li className={eleRef.props.location.pathname=="/trying-to-conceive"?"baby_child1 active_cl":"baby_child1"}>
                        <a href="/trying-to-conceive" tabIndex={0} aria-label='Select Profile : Trying to Conceive'>
                          <div className="baby_circle_child1">
                            <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/07 Trying to concieve.webp"  alt="Trying to Conceive" title="Trying to Conceive"/> 
                          </div>
                          <h2 className="infant_name_baby M14_21"> Trying to Conceive </h2>
                          <div className="infant_name_dis M14_61"> </div>
                          </a>
                        </li>

                       
                      </ul>
                  </div>
            </section>
            
            }
            </div>
          )
}
